import type { MulticastSettingsState } from "Interfaces";
import { createAppSlice } from "Data/Redux/Store";
import type { PayloadAction } from "@reduxjs/toolkit";
import { constant, times } from "lodash";

const initialState: MulticastSettingsState = {
	enable: [ true, false, false, false, false, false ],
	multicastAddresses: times(6, constant("239.248.209.48")),
	port: times(6, constant(26384)),
	ttl: times(6, constant(60))
};

// #region reducers
export const setMulticastSettingsReducer = (
	state: MulticastSettingsState,
	action: PayloadAction<MulticastSettingsState>
) => {
	if (!action.payload) {
		return;
	}

	return action.payload;
};

// #endregion

// #region selectors
const getMulticastSettings = (state: MulticastSettingsState) => {
	return state;
};

// #endregion

const multicastSettingsSlice = createAppSlice({
	name: "multicastSettings",
	initialState,
	reducers: {
		setMulticastSettingsAction: setMulticastSettingsReducer
	},
	selectors: {
		selectMulticastSettings: getMulticastSettings
	}
});

export default multicastSettingsSlice;

export const { setMulticastSettingsAction } = multicastSettingsSlice.actions;
export const { selectMulticastSettings } = multicastSettingsSlice.selectors;
